import React from 'react';
import type { EntriesDetails } from '@betterpool/api-types';
import { useMantineTheme, Progress, Group, Box } from '@mantine/core';

import { ReturnPercentage } from '~/components/utils/formatters';
import { useIsTablet } from '~/domains/common/hooks/mediaQueries';
import type { Contest } from '~/domains/contest/domains/services/interfaces/contest.interface';
import { Text } from '~/domains/design-system/Text';
import useIsUserAuthorised from '~/domains/auth/hooks/useIsUserAuthorised';

function getContestMaxEntriesLabel(entries: EntriesDetails) {
  return entries.max === 0 && entries.is_unlimited_entries ? '∞' : entries.max;
}

function ContestEntryColumn({ contest }: { contest: Contest }) {
  const theme = useMantineTheme();
  const isTablet = useIsTablet();
  const maxEntries = getContestMaxEntriesLabel(contest.entries);
  const isUserAuthorised = useIsUserAuthorised();

  return (
    <Box w="90%">
      <Group position="apart" noWrap>
        <Text tag="div" variant="body-medium">
          {contest.entries.filled} / {maxEntries}
        </Text>
        {!isTablet && (
          <Text tag="div" variant="body-small" color={theme.colors.gray[6]}>
            (
            {isUserAuthorised
              ? `${contest.entries.user ?? 0} / ${contest.entries.max_per_user === 0 ? '∞' : contest.entries.max_per_user}`
              : `Filled: ${ReturnPercentage(contest.entries.filled, maxEntries).toFixed(0)}%`}
            )
          </Text>
        )}
      </Group>
      <Progress
        mt={theme.other.spacing._8}
        sections={[
          {
            value: ReturnPercentage(contest.entries.filled, contest.entries.max),
            color: 'primary',
          },
          {
            value: 100,
            color: theme.colors.gray[2],
          },
        ]}
      />
    </Box>
  );
}

export default ContestEntryColumn;
